import axios from '@/lib/axios';
import { SalesOrderOutline } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2640. 以前のプロジェクト（売上）登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/prev_sales_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  prev_sales_order_id: number;
};
const createPrevSalesOrder = (props: Props): Promise<SalesOrderOutline> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/prev_sales_orders`,
    props
  );
};

export const useCreatePrevSalesOrder = () => {
  return useMutation({
    mutationFn: createPrevSalesOrder,
  });
};
